import React from "react";
import { ActionsMenu } from "../../common/components/ActionsMenu";
import { ConditionalWrapper } from "../../common/components/ConditionalWrapper";
import { MENU_TABS, MODAL_CUSTOMIZE_QUICK_SEARCH } from "../../common/components/modals/constants";
import useModal from "../../common/components/modals/useModal";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { ActionsMenuButton } from "../actions/ActionsMenuButton";
import { AdvancedSearch } from "../advanced-search/AdvancedSearch";
import { PrintResultsButton } from "./PrintResultsButton";
import { SupportLink } from "./SupportLink";
import { ClearSearch } from "../components/ClearSearch";
import { supportLinkType } from "../../common/types/search/search";

interface SearchButtonsProps {
	customizeQuickSearchEnabled: boolean;
	namespace: string;
	onClearSearch: () => void;
	supportLink?: supportLinkType;
}

export function SearchButtons({
	customizeQuickSearchEnabled,
	onClearSearch,
	namespace,
	supportLink,
}: SearchButtonsProps) {
	const { onOpenModal } = useModal();
	const { isMobile, isTablet } = useAccessWindowSize();
	const showMenu = isMobile || isTablet;

	const handleCustomizeQuickSearchClick = () => {
		onOpenModal(MODAL_CUSTOMIZE_QUICK_SEARCH);
	};

	return (
		<div className="btn-group">
			<ConditionalWrapper
				condition={showMenu}
				wrapper={(children) => (
					<ActionsMenu id={MENU_TABS}>{children}</ActionsMenu>
				)}
			>
				<SupportLink supportLink={supportLink} />

				<AdvancedSearch />

				{customizeQuickSearchEnabled && (
					<button
						type="button"
						className="btn btn--secondary btn--has-icon btn--customize"
						onClick={handleCustomizeQuickSearchClick}
					>
						<span>Customise quick search</span>
					</button>
				)}

				<PrintResultsButton />

				<ClearSearch
					onClearSearch={onClearSearch}
					namespace={namespace}
				/>
			</ConditionalWrapper>

			{showMenu && (
				<ActionsMenuButton onClick={() => onOpenModal(MENU_TABS)} />
			)}
		</div>
	);
}
